import fetch from 'auth/GenericFetchInterceptorV5';

const GruppiMerceologiciService = {};

GruppiMerceologiciService.getAll = function (companyDocumentId) {
    return fetch({
        url: `/api/merchandise-groups?filters[company][documentId][$eq]=${companyDocumentId}&populate[0]=conto_dare&populate[1]=conto_avere&pagination[limit]=500&sort=nome:asc`,
        method: 'GET',
    });
};

GruppiMerceologiciService.create = function (data) {
    return fetch({
        url: `/api/merchandise-groups`,
        method: 'POST',
        data: { data },
    });
};

GruppiMerceologiciService.update = function (documentId, data) {
    return fetch({
        url: `/api/merchandise-groups/${documentId}`,
        method: 'PUT',
        data: { data },
    });
};

export default GruppiMerceologiciService;
